export default __webpack_public_path__ + "static/media/watsoo.2141102f.png";